import { XTime, difference, parseFormatDay } from "@/utils/time";

export default {
  computed: {
    timeFormat() {
      return (time) => {
        return time === undefined ? " " : XTime(time);
      };
    },
    differTime() {
      return (start, end) => {
        return difference(start, end);
      };
    },
    parseFormatDay() {
      return (date) => {
        return parseFormatDay(date);
      };
    },
    isBefore60Days() {
      return (endTime) => {
        const now = Math.floor(Date.now() / 1000);
        const sixtyDays = 60 * 24 * 60 * 60;

        return endTime < now - sixtyDays;
      };
    },
  },
};
